(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', ()=>{
   let announcemnet$bar = new Swiper('.WpSwiperLayoutBar.swiper', { slidesPerView: 1, loop: true,autoplay: {delay: 3000} }); 
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hume-band-how-it-works"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.Hume-bandbanner-imagpopup').forEach(function(element) {
      element.addEventListener('click', function() {
        document.querySelector('.Hume-popup-overlay').classList.add('active');
        let popupVd = document.querySelector('.Hume-popup-overlay').querySelectorAll('video');
        popupVd.forEach((vd)=>{
          if (vd.paused) { vd.play() }
        })
      });
    });
    document.querySelectorAll('.Hume-popup-close').forEach(function(element) {
      element.addEventListener('click', function(event) {
        event.stopPropagation();
        document.querySelector('.Hume-popup-overlay').classList.remove('active');
        let popupVdC = document.querySelector('.Hume-popup-overlay').querySelectorAll('video');
        popupVdC.forEach((vd)=>{
          if (!vd.paused) { vd.pause() } 
        })        
      });
    });
  });  

  $(document).ready(function(){
  $('.Humeband-block-button').on('click', function(){
    // Select the target section by class
    $('html, body').animate({
      scrollTop: $('.WillNotShowOnBodyPodPDMN').offset().top
    }, 1000); // 1000ms for smooth scrolling
  });
});
  $('.Hume-bandbanner-imagpopup').click(function(){
    $('body').addClass("howworkstart");
  });
  $('.Hume-popup-close').click(function(){
     $('body').removeClass("howworkstart");
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hume-band-measurement"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
      const container = document.querySelector('.HumeBand-box-outer');
      const blocks = [
          {
              selector: '.Measurement-first-block',
              activeAddOffset: 200,
              activeRemoveOffset: 600,
              containerAddOffset: 300,
              containerRemoveOffset: 900,
              containerClass: 'firstActive'
          },
          {
              selector: '.Measurement-second-block',
              activeAddOffset: 300,
              activeRemoveOffset: 470,
              containerAddOffset: 300,
              containerRemoveOffset: 470,
              containerClass: 'secondActive'
          },
          {
              selector: '.Measurement-third-block',
              activeAddOffset: 500,
              activeRemoveOffset: 900,
              containerAddOffset: 500,
              containerClass: 'thirdActive'
          }
      ];

      function checkScrollPosition() {
          blocks.forEach(block => {
              const element = document.querySelector(block.selector);
              if (!element) return;
              let rect = element.getBoundingClientRect();
              let isActive = rect.top >= 0 - block.activeAddOffset && rect.top <= window.innerHeight - block.activeAddOffset;
              let shouldRemoveActive = rect.top < 0 - block.activeRemoveOffset || rect.top > window.innerHeight;
              let isContainerActive = rect.top >= 0 - block.containerAddOffset && rect.top <= window.innerHeight - block.containerAddOffset;
              let shouldRemoveContainer = rect.top < 0 - block.containerRemoveOffset || rect.top > window.innerHeight;
              if (isActive) {
                  element.classList.add('active');
              } else if (shouldRemoveActive) {
                  element.classList.remove('active');
              }
              if (isContainerActive) {
                  container.classList.add(block.containerClass);
              } else if (shouldRemoveContainer) {
                  container.classList.remove(block.containerClass);
              }
          });
      }
      window.addEventListener('scroll', checkScrollPosition);
      window.addEventListener('resize', checkScrollPosition);
      checkScrollPosition();


    document.querySelectorAll('[js-popup-advertise]').forEach((elm)=>{
      elm.addEventListener('click', (target)=>{
        target.preventDefault();
        let targetElementpopup = target.currentTarget.dataset.popup;
        document.querySelector(`.HH-band-tile_expend[data-open-popup="${targetElementpopup}"]`).classList.add('active');
        document.body.classList.add('band-exprend-active');
      })
    })

    document.querySelectorAll('[js-popup-advertise-close]').forEach((elm)=>{
      elm.addEventListener('click', (target)=>{
        target.preventDefault();
        document.querySelectorAll('.HH-band-tile_expend').forEach((elm)=>{elm.classList.remove('active')});
        document.body.classList.remove('band-exprend-active');
      })
    })    

    
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hume-band-testimonial"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener("DOMContentLoaded", function () {
        const slides = document.querySelectorAll('.testimoniolblock_slider');
        const prevButton = document.querySelector('.prev-swiper-button');
        const nextButton = document.querySelector('.next-swiper-button');
        const currentSlide = document.querySelector('.current-swiper-slide');
        const totalSlides = document.querySelector('.swiper-slides-total');
        let slideOrder = [0, 1, 2];
        const totalSlideCount = slides.length;
        totalSlides.textContent = totalSlideCount;
        function updateSlider() {
            slides.forEach(slide => slide.classList.remove('is-active'));
            slides[slideOrder[1]].classList.add('is-active');
            currentSlide.textContent = slideOrder[1] + 1;
        }
        function nextSlide() {
            slideOrder = [slideOrder[1], slideOrder[2], slideOrder[0]];
            reorderSlides();
        }
        function prevSlide() {
            slideOrder = [slideOrder[2], slideOrder[0], slideOrder[1]];
            reorderSlides();
        }
        function reorderSlides() {
            const parent = slides[0].parentNode;
            slideOrder.forEach(index => parent.appendChild(slides[index]));
            updateSlider();
        }
        nextButton.addEventListener('click', nextSlide);
        prevButton.addEventListener('click', prevSlide);
        updateSlider();
      if (window.innerWidth < 750) {
        var swiper = new Swiper(".HumeBandswiper_container", {
          slidesPerView: 1.1, // Show only 1 full slide and a bit of the next
          spaceBetween: 13,
          loop: true,
          initialSlide: 1,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          on: {
            init: function () {
              updateSlideNumbers(this);
            },
            slideChange: function () {
              updateSlideNumbers(this);
            },
          },
        });
        function updateSlideNumbers(swiper) {
          document.querySelector(".swiper-current-slide").textContent = swiper.realIndex + 1;
        }
      }
  });  

  } catch(e) { console.error(e); }
})();
})();
